var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logos-container"},[_c('img',{class:_vm.logo.class,attrs:{"src":require(`@/assets/images/${_vm.logo.source}`),"alt":_vm.logo.name}})])
}
var staticRenderFns = []

export { render, staticRenderFns }